import { numberLiteral } from "./const-array";
import * as t from "io-ts";
export const weekdayT = numberLiteral([1, 2, 3, 4, 5, 6, 7], "Weekday");
export const weekdaysT = t.array(weekdayT);
//# sourceMappingURL=weekday.js.map